/**
 * Toast Notification System
 */
let container = null;

function escapeHtml(value) {
  const node = document.createElement("div")
  node.textContent = value ?? ""
  return node.innerHTML
}

export const ToastManager = {
  init() {
    container = document.getElementById("nw-toast-container")
    if (!container) {
      container = document.createElement("div")
      container.id = "nw-toast-container"
      container.className = "nw-toast-container"
      container.setAttribute("aria-live", "polite")
      container.setAttribute("aria-atomic", "true")
      document.body.appendChild(container)
    }

    document.querySelectorAll("[data-nw-toast-demo]").forEach((btn) => {
      btn.addEventListener("click", () => {
        this.show({
          type: btn.dataset.nwToastDemo,
          title: btn.dataset.nwToastTitle || "Notification",
          message: btn.dataset.nwToastMessage || "This is a sample notification.",
        })
      })
    })
  },

  show({ type = "info", title, message, url, persistent = false }) {
    this.init()

    const id = `toast-${Date.now()}`
    const iconMap = {
      success: "bi-check-circle-fill text-success",
      info: "bi-info-circle-fill text-info",
      warning: "bi-exclamation-triangle-fill text-warning",
      danger: "bi-x-circle-fill text-danger",
    }

    const closeButton = persistent
      ? ""
      : '<button type="button" class="btn-close" data-action="close" aria-label="Close"></button>'
    const openLink = url
      ? `<a class="btn btn-sm btn-primary" data-turbo-method="patch" href="${escapeHtml(url)}">Open</a>`
      : ""

    container.insertAdjacentHTML("beforeend", `
      <div id="${id}" class="toast show nw-toast nw-toast--${escapeHtml(type)}" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="toast-header">
          <i class="bi ${iconMap[type] || iconMap.info} me-2"></i>
          <strong class="me-auto"></strong>
          <small class="text-muted">just now</small>
          ${closeButton}
        </div>
        <div class="toast-body">
          <p class="mb-2 toast-message"></p>
          ${openLink}
        </div>
      </div>
    `)

    const el = document.getElementById(id)
    const titleNode = el?.querySelector(".me-auto")
    const messageNode = el?.querySelector(".toast-message")
    if (titleNode) titleNode.textContent = title || "Notification"
    if (messageNode) messageNode.textContent = message || ""

    if (!persistent) {
      setTimeout(() => {
        el?.classList.remove("show")
        setTimeout(() => el?.remove(), 300)
      }, 5000)
    }

    el?.querySelector(".btn-close")?.addEventListener("click", () => {
      el.classList.remove("show")
      setTimeout(() => el.remove(), 300)
    })
    return el
  },
}
